module.exports = __webpack_public_path__ + "static/media/PoppinsRegular400.29cc97af.ttf";